<template>
    <div class="card">
        <div class="flex card-container blue-container overflow-hidden">
            <div class="flex-none flex align-items-center justify-content-center py-2">
                <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined" @click="cierraVentana()" v-tooltip.right="'Cerrar'" />
            </div>
            <h1 class="flex-grow-1 flex align-items-center justify-content-center py-2">Configuración Conceptos con Capítulo</h1>
            <div class="flex-none flex align-items-center justify-content-center py-2">
                <Button icon="pi pi-save" class="p-button-rounded p-button-success p-button-outlined" @click="GuardaConfiguracion()" v-tooltip.right="'Guardar'" />
                <Button icon="mdi mdi-checkbox-blank-circle-outline" class="p-button-rounded p-button-success p-button-outlined" @click="GetConfiguracion()" v-tooltip.right="'Guardar'" />
            </div>
        </div>
        <hr size=7 color="#FF6699">
        <div class="flex justify-content-center flex-wrap card-container">
            <Chips v-model="listPuestos" >
                <template #chip="slotProps">
                    <div>
                        <span>{{slotProps.value.puesto}}</span>
                    </div>
                </template>
            </Chips>
        </div>
        <div>
            <TabView>
                <TabPanel header="Percepciones">
                    <div>
                        <DataTable :value="listPercepciones" :scrollable="true" scrollHeight="600px" scrollDirection="both" :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown":rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" :loading="loadingPercepciones" :filters.sync="filtrosPercepciones">
                            <template #header>
                                <div class="flex justify-content-center flex-wrap card-container">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText v-model="filtrosPercepciones['global'].value" placeholder="Buscar" />
                                    </span>
                                </div>
                            </template>
                            <Column field="clave" header="Clave" :styles="{'width':'2rem', 'min-width':'6rem'}">
                            </Column>
                            <Column field="concepto" header="Concepto" :styles="{'width':'2rem', 'min-width':'10rem'}">
                            </Column>
                            <Column header="Cuenta OG" :styles="{'width':'40rem', 'min-width':'20rem'}">
                                <template #body="rowData">
                                    <AutoComplete class="grande-autocomplete" v-model="rowData.data.cuenta" :suggestions="filteredCuentaOG" @complete="searchCuentaOG($event)" field="cuenta" />
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </TabPanel>
                <TabPanel header="Otros Pagos">
                    <div>
                        <DataTable :value="listOtrosPagos" :scrollable="true" scrollHeight="600px" scrollDirection="both" :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown":rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" :loading="loadingPercepciones" :filters.sync="filtrosOtrosPagos">
                            <template #header>
                                <div class="flex justify-content-center flex-wrap card-container">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText v-model="filtrosOtrosPagos['global'].value" placeholder="Buscar" />
                                    </span>
                                </div>
                            </template>
                            <Column field="clave" header="Clave" :styles="{'width':'2rem', 'min-width':'2rem'}">
                            </Column>
                            <Column field="concepto" header="Concepto" :styles="{'width':'10rem', 'min-width':'10rem'}">
                            </Column>
                            <Column header="Cuenta OG" :styles="{'width':'30rem', 'min-width':'30rem'}">
                                <template #body="rowData">
                                    <AutoComplete class="grande-autocomplete"  v-model="rowData.data.cuenta" :suggestions="filteredCuentaOG" @complete="searchCuentaOG($event)" field="cuenta"/>
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </TabPanel>
            </TabView>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import { FilterMatchMode, FilterOperator } from "primevue/api/";

    export default {
        components: {
            
        },
        data() {
            return {
                loadingPercepciones: false,
                listPercepciones: [],
                filtrosPercepciones: {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                },
                listOtrosPagos: [],
                filtrosOtrosPagos: {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                },
                listCuentaOG: [],
                selectedCuentaOG: null, 
                filteredCuentaOG: null,
                selectedOption: null,

            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            listPuestos(){
                return this.$store.state.listPuestosStore;
            }
            
        },
        created() {
            this.GetIniciales();
        },

        methods: {
            formatCurrency(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },

            formtaDate(value){
                return moment(value).format('DD-MM-YYYY')
            },

            async GetIniciales(){
                this.loadingPercepciones = true;
                await this.GetPercepciones();
                await this.GetOtrosPagos();
                await this.GetCuentaOG();
                await this.GetConfiguracion();
                this.loadingPercepciones = false;
            },

            async GetPercepciones(){
                try{
                    let response =  await axios.get('ReporteNominas/GetPercepcionesMil/'+ this.token.empresaBase);
                    let x = response.data;
                    this.listPercepciones = x;
                }catch(error){
                    console.log(error);
                }
            },

            async GetOtrosPagos(){
                try{
                    let response =  await axios.get('ReporteNominas/GetOtrosMil/'+ this.token.empresaBase);
                    let x = response.data;
                    this.listOtrosPagos = x;
                }catch(error){
                    console.log(error);
                }
            },

            async GetCuentaOG(){
                try{
                    let response =  await axios.get('ReporteNominas/GetCatalogoMil/'+ this.token.empresaBase);
                    let x = response.data;
                    this.listCuentaOG = x;
                }catch(error){
                    console.log(error);
                }
            },
            
            searchCuentaOG(event){
                setTimeout(() => {
                if (!event.query.trim().length) {
                    this.filteredCuentaOG = [...this.listCuentaOG];
                }
                else {
                    this.filteredCuentaOG = this.listCuentaOG.filter((country) => {
                        return country.cuenta.toLowerCase().includes(event.query.toLowerCase());
                    });
                }
            }, 250);
            },

            cierraVentana(){
                this.$emit('closeDialogConfig')
            },

            async GuardaConfiguracion(){
                // console.log(this.listPercepciones)
                let listaConfig = [];
                for(let x of this.listPuestos){
                    for(let y of this.listPercepciones){
                        if(y.hasOwnProperty('cuenta')){
                            let ObjConfig = {
                                puesto: x.puesto,
                                clave: y.clave,
                                concepto: y.concepto,
                                idCuentaOg: y.cuenta.id,
                            }
                            listaConfig.push(ObjConfig)
                        }
                    }
                }
                // console.log(listaConfig)
                await this.PostConfiguracion(listaConfig)
            },

            async PostConfiguracion(item){
                try{
                    let response = await axios.post('ReporteNominas/PostConfigCapituloMil/'+ this.token.empresaBase , item);
                    console.log(response.data);
                }catch(error){
                    console.log(error)
                }
            },
        
            async GetConfiguracion(){
                let lista = this.$store.state.listPuestosStore.map(item => item.puesto);
                // console.log(lista)
                try{
                    let response =  await axios.post('ReporteNominas/GetConfifCapituloMil/' + this.token.empresaBase, lista);
                    console.log(response.data)
                    let x = response.data;

                    for(let a of this.listPercepciones){
                        let cuenta = {}
                        cuenta = x.find(y => y.clave === a.clave);
                        if(cuenta){
                            a.cuenta = {...cuenta.cuentaMil};
                            cuenta = {}
                        }
                    }
                    console.log(this.listPercepciones)

                }catch(error){
                    console.log(error)
                }
            },
        },
    }
</script>
<style >
.grande-autocomplete .p-autocomplete-input  {
    width: 500px !important;
}


</style>